import { useEffect, useState } from "react";
import { Render } from "@puckeditor/core";
import { useParams, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Oval } from "react-loader-spinner";

import Navbar from "./Navbar";
import Footer from "./Footer";
import { config } from "../Config";
import axiosClient from "../axios-client";

const Home = () => {
  // 1. Get ID from URL parameters, or default to 1 (Home)
  const { id } = useParams();
  const pageId = id || 1;

  const [data, setData] = useState({
    content: [],
    root: {},
    zones: {},
  });

  const [isLoading, setIsLoading] = useState(true);
  const token = useSelector((state) => state.dropdown.token);

  useEffect(() => {
    const getContent = async () => {
      setIsLoading(true);
      try {
        // This hits your local server.js
        const response = await axiosClient.get(`/pages/${pageId}`);

        // Ensure we always have the core Puck keys
        const puckData = response.data.data;
        setData({
          content: puckData.content || [],
          root: puckData.root || {},
          zones: puckData.zones || {},
        });
      } catch (error) {
        console.error("Failed to fetch page content:", error);
      } finally {
        setIsLoading(false);
      }
    };

    getContent();
  }, [pageId]); // Re-run if the page ID changes

  return (
    <div className="relative bg-[#EAEFFB] min-h-screen flex flex-col">
      <div className="border-b bg-[#FFFFFF]">
        <Navbar />
      </div>

      <main className="flex-grow">
        {isLoading ? (
          <div className="w-full h-[60vh] flex items-center justify-center">
            <Oval
              visible={true}
              height="80"
              width="80"
              color="#313230"
              secondaryColor="#313230"
              ariaLabel="oval-loading"
            />
          </div>
        ) : (
          /* Render the dynamic content from the JSON file */
          <Render config={config} data={data} />
        )}
      </main>

      {/* Show Builder Link if not logged in (or based on your token logic) */}
      {!token && (
        <Link
          to={`/builder/${pageId}`}
          className="fixed bottom-10 right-10 px-6 py-3 bg-gradient-to-r from-blue-600 to-indigo-700 rounded-full shadow-2xl text-white font-bold text-lg transition-transform hover:scale-110 z-50 animate-bounce"
        >
          ✏️ Edit Page
        </Link>
      )}

      <Footer />
    </div>
  );
};

export default Home;
